
<template>
    <div class="SearchEmptyState" v-if="type === 'search'">
        <i class="material-icons-outlined">error_outline</i>
        <span v-html="$t('emptyState.SEARCH_NO_RESULTS', { query: message })"></span>
    </div>


    <div v-else class="emptyState" :class="{'emptyState--pink': color === 'pink'}">
        <i class="emptyState__icon material-icons-outlined" :class="{'emptyState__icon--pink': color === 'pink'}" >{{icon}}</i>
        <div class="emptyState__content">
            <h5 class="emptyState__content--title" :class="{'emptyState__content--title--pink': color === 'pink'}">{{title}}</h5>
            <div v-html="message" class="emptyState__content--message"></div> 
            <span v-if="subMessage !== undefined" class="emptyState__content--submessage">{{subMessage}}</span>
        </div>
        <div class="emptyState__actions">
            <div  @change="if(!uploadLoading) { uploadFile($event); uploadLoading = true  }" class="upload-file__container" :class="{'upload-file__container--loading': uploadLoading}" v-if="uploadFileView" >
                <label for="upload-file">
                    {{ $t('emptyState.UPLOAD_FILE') }}
                    <i class="material-icons">file_upload</i>
                </label>
                <input type="file" accept=".doc,.docx,.ppt,.pptm,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.xls,.xlsx" name="attach" id="upload-file">
            </div>
        </div>
    </div>
</template>


<script>
import { ref } from 'vue';

export default {
    props:['icon','title','message', 'subMessage', 'uploadFileView', 'color', "type"],
    emit: ['uploadFile'],
    setup(props, {emit}) {
        const uploadLoading = ref(false)
        const uploadFile = (event) => {
            emit("uploadFile", event)
            uploadLoading.value = false
        }

        return{
            uploadLoading,
            uploadFile
        }
    },
}
</script>

<style lang="scss" scoped>
@import "@/styles/main.scss";
.SearchEmptyState{
    display: flex;
    align-items: center;
    gap: 10px;
    border-radius: 10px;
    padding: 24px;
    background-color: #ffddd7;
    width: fit-content;
    color: #F57055;
    span{
        color: $black;
    }
    strong{
        color: #F57055;
    }
}
.emptyState{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;
    background-color: rgba(189, 228, 228, 0.5);
    padding: 54px 24px;
    &--pink{
        background-color: #F5EEF5;
    }
    .emptyState__icon{
        color: #fff;
        padding: 18px;
        background-color: #54C5C5;
        border-radius: 1000px;
        font-size: 24px;
        &--pink{
            background-color: #C79CC3;
        }
    }
    &__content{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 12px;
        &--title{
            font-weight: 600;
            font-size: 20px;
            color: $green;
            text-align: center;
            &--pink{
                color: #9E5498;
            }
            @media screen and (max-width: 860px){
                font-size: 16px
            }
        }
        &--message{
            font-weight: 400;
            font-size: 16px;
            color: $black;
            text-align: center;
            line-height: 36px;
            @media screen and (max-width: 860px){
                font-size: 14px;
                line-height: 28px;
            }
        }
        &--submessage{
            font-weight: 600;
            font-size: 16px;    
            color: $black;
            text-align: center;
            @media screen and (max-width: 860px){
                font-size: 12px;
            }
        }
    }

    .upload-file__container{
    display: inline-block;
    position: relative;
    left: 0;
    text-align: center;
    #upload-file{
        visibility: hidden;
        position: absolute;
        width: 0px;
        height: 0px;
        top: 0;
        left: 0;
    }
    label,span{
        width: fit-content;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        border: 2px solid $green;
        background: inherit;
        border-radius: 44px;
        color: $green;
        font-size: 14px;
        font-weight: 600;
        padding: 8px 18px;
        cursor: pointer;
        .material-icons{
            color: $green;
            font-size: 16px;
        }
    }
    &--loading{
        label{
            cursor: default;
            opacity: .5;
        }
    }
}
}

</style>